import React, { Component } from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';

import Loader from './loader';

class BacteriaMedia extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isEntering: false,
            isExiting: false,
            isVisible: false,
            isChanging: false,
            visibleFeature: null,
            videoIsLoading: true
        };

        this._videoHadLoaded = this._videoHadLoaded.bind( this );
    }

    shouldComponentUpdate() {
        const { isExiting } = this.state;
        return !isExiting;
    }

    componentDidUpdate( prevProps ) {
        const { activeFeature } = this.props;
        const { visibleFeature, isVisible, videoIsLoading } = this.state;

        if( (visibleFeature === null && activeFeature !== null) || (!isVisible && visibleFeature !== activeFeature) ){
            if( this._featureHasMedia(activeFeature) ) {
                this.setState({
                    isEntering: true,
                    isChanging: false,
                    isExiting: false,
                    isVisible: true,
                    visibleFeature: activeFeature
                });
            }
        }
        if( isVisible && visibleFeature !== activeFeature ){
            if( !this._featureHasMedia(activeFeature) ){
                this._hideMedia();
                setTimeout( () => {
                    this.setState({
                        isEntering: false,
                        isChanging: false,
                        visibleFeature: activeFeature
                    });
                }, 1000);
            }else{
                this.setState({
                    isEntering: false,
                    isChanging: true,
                    visibleFeature: activeFeature
                });
                setTimeout( () => {
                    this.setState({
                        isChanging: false
                    });
                }, 500);
            }
        }
        if( activeFeature !== null && prevProps.activeFeature === null ||
            ( activeFeature !== null && prevProps.activeFeature !== null && activeFeature.video !== prevProps.activeFeature.video ) ) {
            this.setState({
               videoIsLoading: true
            });
        }
    }

    _hideMedia() {
        const { isVisible } = this.state;
        if( isVisible ) {
            this.setState({
                isExiting: true
            });
            setTimeout(() => {
                this.setState({
                    isVisible: false,
                    isExiting: false
                });
            }, 1000);
        }
    }

    _featureHasMedia( featureId ){
        const { features } = this.props;

        if( features[featureId] !== undefined && features[featureId] !== null ){
            if( features[featureId].image !== null || features[featureId].video !== null ){
                return true;
            }
        }

        return false;
    }

    _videoHadLoaded() {
        this.setState({
            videoIsLoading: false
        });
    }

    render() {
        const { features } = this.props;
        const { isVisible, visibleFeature, isExiting, isChanging, isEntering, videoIsLoading } = this.state;

        if( !isVisible ){ return null; }

        const feature = features[visibleFeature];
        const { title, image, video } = feature;

        const classes = classnames(
            'bacteria-media',
            { 'bacteria-media-entering': isEntering },
            { 'bacteria-media-exiting': isExiting },
            { 'bacteria-media-changing': isChanging }
        );

        const loaderClasses = classnames(
            { 'loaded': !videoIsLoading }
        );

        return(
            <div key={classes} className={classes}>
                <div className="circle-content">
                    { image !== null &&
                        <img src={ image } alt={ title } />
                    }
                    { video !== null &&
                        <div className="video-container">
                            <video autoPlay loop onPlay={ this._videoHadLoaded }>
                                <source src={ video } type="video/mp4" />
                            </video>
                            <Loader className={ loaderClasses } text="Loading Video..." />
                        </div>
                    }
                </div>
            </div>
        );
    }

}

const mapStateToProp = ( state ) => {
    return {
        activeFeature: state.activeFeature
    }
};

export default connect(mapStateToProp)(BacteriaMedia);


// WEBPACK FOOTER //
// ./src/components/bacteria-media.js